/// <reference types="./legacyDecodeEntityFields.d.ts" />
import { FieldType, isRichTextComponentNode, ok, transformRichText, } from '@dossierhq/core';
import * as LegacyCodecFieldTypeAdapters from './LegacyCodecFieldTypeAdapters.js';
export function legacyDecodeEntityFields(schema, entitySpec, encodedFields) {
    const decodedFields = {};
    for (const fieldSpec of entitySpec.fields) {
        const { name: fieldName } = fieldSpec;
        const fieldValue = encodedFields[fieldName];
        decodedFields[fieldName] = decodeFieldItemOrList(schema, fieldSpec, 'optimized', fieldValue);
    }
    return decodedFields;
}
function decodeFieldItemOrList(schema, fieldSpec, codecMode, fieldValue) {
    if (fieldValue === null || fieldValue === undefined) {
        return null;
    }
    const fieldAdapter = LegacyCodecFieldTypeAdapters.getAdapter(fieldSpec);
    if (fieldSpec.list) {
        if (!Array.isArray(fieldValue)) {
            throw new Error(`Expected list but got ${fieldValue} (${fieldSpec.name})`);
        }
        const decodedItems = [];
        for (const encodedItem of fieldValue) {
            if (fieldSpec.type === FieldType.Component) {
                const decodedItem = decodeComponentField(schema, codecMode, encodedItem);
                if (decodedItem) {
                    decodedItems.push(decodedItem);
                }
            }
            else if (fieldSpec.type === FieldType.RichText) {
                decodedItems.push(decodeRichTextField(schema, encodedItem));
            }
            else {
                decodedItems.push(codecMode === 'optimized'
                    ? fieldAdapter.decodeData(encodedItem)
                    : fieldAdapter.decodeJson(encodedItem));
            }
        }
        return decodedItems.length > 0 ? decodedItems : null;
    }
    if (fieldSpec.type === FieldType.Component) {
        return decodeComponentField(schema, codecMode, fieldValue);
    }
    if (fieldSpec.type === FieldType.RichText) {
        return decodeRichTextField(schema, fieldValue);
    }
    return codecMode === 'optimized'
        ? fieldAdapter.decodeData(fieldValue)
        : fieldAdapter.decodeJson(fieldValue);
}
function decodeComponentField(schema, codecMode, encodedValue) {
    const componentSpec = schema.getComponentTypeSpecification(encodedValue.type);
    if (!componentSpec) {
        // Could be that the component type was deleted or made adminOnly (when decoding published entities)
        return null;
    }
    const decodedValue = { type: encodedValue.type };
    for (const fieldFieldSpec of componentSpec.fields) {
        const fieldName = fieldFieldSpec.name;
        const fieldValue = encodedValue[fieldName];
        decodedValue[fieldName] = decodeFieldItemOrList(schema, fieldFieldSpec, codecMode, fieldValue);
    }
    return decodedValue;
}
function decodeRichTextField(schema, encodedValue) {
    const path = [];
    return transformRichText(path, encodedValue, (_path, node) => {
        if (isRichTextComponentNode(node)) {
            const data = decodeComponentField(schema, 'json', node.data);
            if (!data) {
                return ok(null);
            }
            const newNode = { ...node, data };
            return ok(newNode);
        }
        return ok(node);
    }).valueOrThrow();
}
//# sourceMappingURL=legacyDecodeEntityFields.js.map